import React from "react";

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const UNSAVED_CHANGES_MESSAGE =
  "保存されていない入力内容があります。このまま移動しますか？";

const UnsavedChangesModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: UnsavedChangesModalProps) => (
  <div
    className={`absolute inset-0 z-50 flex items-center justify-center bg-white/70 px-[24px] transition-opacity duration-200 ${
      isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
    }`}
  >
    <div className="w-full max-w-[460px] rounded-[6px] border border-[#1b4b86] bg-white p-[28px] shadow-[0_8px_24px_rgba(0,0,0,0.18)]">
      <h2 className="border-l-[4px] border-[#1b4b86] pl-[12px] text-[20px] font-bold leading-[1.6] text-[#1b4b86]">
        確認
      </h2>

      <p className="mt-[24px] text-[15px] leading-[1.8] text-black">
        {UNSAVED_CHANGES_MESSAGE}
      </p>

      <div className="mt-[28px] grid grid-cols-2 gap-[15px]">
        <button
          className="flex h-[46px] items-center justify-center rounded-[6px] bg-[#eef5fa] text-[16px] font-bold leading-[1.6] text-[#1b4b86]"
          onClick={onCancel}
          type="button"
        >
          いいえ
        </button>
        <button
          className="flex h-[46px] items-center justify-center rounded-[6px] bg-[#1b4b86] text-[16px] font-bold leading-[1.6] text-white"
          onClick={onConfirm}
          type="button"
        >
          はい
        </button>
      </div>
    </div>
  </div>
);

export default UnsavedChangesModal;
